import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHome, faToolbox} from "@fortawesome/free-solid-svg-icons";
import "./header.css";


function Header() {
  return (
    <header>
      <Navbar
        bg="light"
        expand="lg"
        className="navbar"
        style={{
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)", // Per compatibilitat amb navegadors basats en Webkit
            backgroundColor: "rgba(255, 255, 255, 0.8)", // Color translúcid
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" // Petita ombra
        }}
        >
        <div className="container-fluid">
            {/* Logo */}
            <Navbar.Brand as={Link} to="/">
            <img
                src="/images/logo/logo-fri-transparent.svg" // Substituït per l'SVG
                alt="Friventca Logo"
                width="150"
            />
            </Navbar.Brand>
        

          {/* Botó de menú per a dispositius mòbils */}
          <Navbar.Toggle aria-controls="navbarNav" />

          {/* Menú de navegació */}
          <Navbar.Collapse id="navbarNav">
            <Nav className="me-auto">
              <Nav.Link href="/#">
                <FontAwesomeIcon icon={faHome} className="nav-link-icon" />
                Inici
              </Nav.Link>
              <Nav.Link href="/#">
                <FontAwesomeIcon icon={faToolbox} className="nav-link-icon" />                  
                Què fem?
              </Nav.Link>

              {/* Desplegable d'Instal·lacions */}
              <NavDropdown title="Instal·lacions" id="navbarDropdown">
                <NavDropdown.Item href="/#">
                   <FontAwesomeIcon icon={faHome} className="nav-link-icon"/>
                   Domèstic
                </NavDropdown.Item>
                <NavDropdown.Item href="/#">
                   <FontAwesomeIcon icon={faHome} className="nav-link-icon"/>
                   Comercial i oficines
                </NavDropdown.Item>
                <NavDropdown.Item href="/#">
                   <FontAwesomeIcon icon={faHome} className="nav-link-icon"/>
                   Industrial
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link href="/#">FAQs</Nav.Link>
              <Nav.Link href="/#">Contacte</Nav.Link>

              {/* Desplegable d'idiomes */}
              <NavDropdown
                title="Idioma" // Només mostra el text
                id="navbarDropdownLanguage"
              >
                <NavDropdown.Item onClick={() => alert("Idioma canviat a Català")}>
                  <img
                    src="/images/banderes/Flag_of_Catalonia.svg"
                    alt="Català"
                    className="flag"
                  />{" "}
                  Català
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => alert("Idioma canviat a Castellano")}>
                  <img
                    src="/images/banderes/Flag_of_Spain.svg"
                    alt="Castellano"
                    className="flag"
                  />{" "}
                  Castellano
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => alert("Idioma canviat a English")}>
                  <img
                    src="/images/banderes/Flag_of_the_United_Kingdom.svg"
                    alt="English"
                    className="flag"
                  />{" "}
                  English
                </NavDropdown.Item>
              </NavDropdown>

            </Nav>

             {/* Botó d'inici de sessió */}
            <div className="ms-auto">
              <button
                className="btn btn-outline-primary"
                onClick={() => (window.location.href = "/login")}
              >
                Inicia sessió
              </button>
            </div>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </header>
  );
}

export default Header;

